export const ChevronSortUp = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.67627 11.7539L16.0085 5.42175L22.2867 11.7" stroke="currentColor" stroke-width="2"/>
</svg>`;
